<template>
  <v-app>
    <v-main style="background-color: #f1f1f1; padding-top: 3rem">
      <v-overlay :value="!onLine" absolute opacity=".8">
        <p class="display-4">{{ langs[this.userLanguage].noNetwork }}</p>
      </v-overlay>
      <v-container fluid style="height: 100%">
        <router-view />
      </v-container>
    </v-main>
    <v-footer padless color="transparent">
      <v-col class="text-center pa-1" cols="12" style="background-color: #f1f1f1">
        {{ new Date().getFullYear() }} — <strong>ABCO {{ version }}</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import moment from "moment";
import packageJSON from "../package.json";

export default {
  name: "App",
  data: () => ({
    onLine: navigator.onLine,
    langs: {
      uz: {
        noNetwork: "Tarmoqga ulanish mavjud emas...",
        errors: {
          getStudentsCount: "Statistika uchun talabalar sonini olishda xatolik!",
          getGroupsCount: "Statistika uchun guruhlar sonini olishda xatolik!",
          getTeachersCount: "Statistika uchun o'qituvchilar sonini olishda xatolik!",
          getStaffersCount: "Statistika uchun xodimlar sonini olishda xatolik!",
        },
        select: {
          branches: {
            noDataText: "Filiallar mavjud emas!",
            label: "Filiallar",
          },
          academicYears: {
            noDataText: "Akademik yillar mavjud emas!",
            label: "Akademik yillar",
          },
        },
        exit: "Akkountdan chiqish",
      },
      ru: {
        noNetwork: "Нет подключения к сети...",
        errors: {
          getStudentsCount: "Ошибка получения количества студентов для статистики!",
          getGroupsCount: "Ошибка получения количества групп для статистики!",
          getTeachersCount: "Ошибка получения количества учителей для статистики!",
          getStaffersCount: "Ошибка получения количества сотрудников для статистики!",
        },
        select: {
          branches: {
            noDataText: "Нет филиалов!",
            label: "Филиалы",
          },
          academicYears: {
            noDataText: "Учебные годы отсутствуют!",
            label: "Учебные годы",
          },
        },
        exit: "Выйти из аккаунта",
      },
    },
  }),
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
      if (type === "online") {
        document.removeEventListener("keydown", this.stopTab);
      } else {
        document.addEventListener("keydown", this.stopTab);
      }
    },
    stopTab(e) {
      if (e.keyCode == 9) {
        e.preventDefault();
      }
    },
    initialize() {
      window.addEventListener("online", this.updateOnlineStatus);
      window.addEventListener("offline", this.updateOnlineStatus);

      if (this.isAuthenticated) {
        this.getData();
      }
    },
  },
  computed: {
    version() {
      return packageJSON.version;
    },
    userLanguage() {
      return "uz";
    },
  },
  mounted() {
    this.initialize();
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>
